<div class="d-flex align-items-center bg-auth border-top border-top-2 border-primary"
     style="height: 100%;min-height:100%;">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-12 col-md-6 col-xl-5 order-md-2 mb-5 mb-md-0">

        <!-- Image -->
        <div class="text-center">
          <img alt="..." class="img-fluid"
               src="/assets/images/email-messaging-email-marketing-campaign_183665-8.webp">
        </div>

      </div>
      <div class="col-12 col-md-6 col-xl-7 order-md-1 my-5">

        <div class="text-center">

          <!-- Preheading -->
          <h6 class="text-uppercase text-muted mb-4">
            Courriel non validé
          </h6>

          <!-- Heading -->
          <h1 class="display-4 mb-5">
            Veuillez maintenant valider votre compte!
          </h1>

          <p class="mb-4">
            Dans vos courriels, vous devriez voir un message venant d'Optitax, vous souhaitant la bienvenue. À
            l'intérieur, vous pourrez cliquer sur le bouton bleu "Confirmer mon compte".
          </p>

          <!-- Subheading -->
          <p class="text-muted mb-4">
            Vous ne voyez pas le courriel? Contactez-nous par clavardage et nous vous assisterons rapidement!
          </p>

          <!-- Button -->
          <a class="btn btn-lg btn-primary" routerLink="/">
            J'ai validé mon courriel!
          </a>

        </div>

      </div>
    </div>
  </div>
</div>
